import { TYPES } from './actions';
import entity from './entity';

import { merge } from '../../../../utils/state';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  sponsorshipCart: {
    ...ReduxRestEntity.initialState,
    data: {},
  },
  receipt: {
    ...ReduxRestEntity.initialState,
    data: {},
  },
  jobPosting: {
    ...ReduxRestEntity.initialState,
  },
  clicks: {
    ...ReduxRestEntity.initialState,
  },
  partners: {
    data: [],
    isLoading: false,
    error: null,
  },
  jobSponsors: {
    ...ReduxRestEntity.initialState,
  },
  overviewReport: ReduxRestEntity.initialState,
  expiredJobSponsorships: ReduxRestEntity.initialState,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.CREATE_CART_REQUEST:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.CREATE_CART_SUCCESS:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          data: {},
          isLoading: false,
          error: false,
        },
      });
    case TYPES.CREATE_CART_FAILURE:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          isLoading: false,
          error: action.payload.error,
        },
      });
    case TYPES.ADD_SPONSORSHIP_ITEM_REQUEST:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.ADD_SPONSORSHIP_ITEM_SUCCESS:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          data: {
            ...state.sponsorshipCart.data,
            ...action.payload.data,
          },
          isLoading: false,
          error: false,
        },
      });
    case TYPES.ADD_SPONSORSHIP_ITEM_ERROR:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          isLoading: false,
          error: true,
        },
      });
    case TYPES.ADD_RECEIPT_ITEM:
      return merge(state, {
        receipt: {
          ...state.receipt,
          data: {
            ...state.receipt.data,
            ...action.payload,
          },
        },
      });
    case TYPES.GET_SPONSORSHIP_ITEMS_REQUEST:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.GET_SPONSORSHIP_ITEMS_SUCCESS:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          data: {
            ...state.sponsorshipCart.data,
            ...action.payload.data,
          },
          isLoading: false,
          error: false,
        },
      });
    case TYPES.GET_SPONSORSHIP_ITEMS_ERROR:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          isLoading: false,
          error: true,
        },
      });
    case TYPES.DELETE_SPONSORSHIP_ITEM_REQUEST:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.DELETE_SPONSORSHIP_ITEM_SUCCESS: {
      const idOfItemToBeDeleted = action.payload.data;
      const { [idOfItemToBeDeleted]: deletedSponsorshipItem, ...restOfSponsorshipCart } = state.sponsorshipCart.data;
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          data: restOfSponsorshipCart,
          isLoading: false,
          error: false,
        },
      });
    }
    case TYPES.DELETE_SPONSORSHIP_ITEM_ERROR:
      return merge(state, {
        sponsorshipCart: {
          ...state.sponsorshipCart,
          isLoading: false,
          error: true,
        },
      });
    case TYPES.GET_DYNAMIC_CLICKS_REQUEST:
      return merge(state, {
        clicks: {
          ...state.clicks,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.GET_DYNAMIC_CLICKS_SUCCESS:
      return merge(state, {
        clicks: {
          ...state.clicks,
          data: action.payload.data,
          isLoading: false,
          error: false,
        },
      });
    case TYPES.GET_DYNAMIC_CLICKS_ERROR:
      return merge(state, {
        clicks: {
          ...state.clicks,
          isLoading: false,
          error: true,
        },
      });
    case TYPES.GET_SPONSORSHIP_PARTNERS_REQUEST:
      return merge(state, {
        partners: {
          ...state.partners,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.GET_SPONSORSHIP_PARTNERS_SUCCESS:
      return merge(state, {
        partners: {
          ...state.partners,
          data: action.payload.data,
          isLoading: false,
          error: false,
        },
      });
    case TYPES.GET_SPONSORSHIP_PARTNERS_ERROR:
      return merge(state, {
        partners: {
          ...state.partners,
          isLoading: false,
          error: true,
        },
      });
    case TYPES.CLEAR_DYNAMIC_CLICKS_STATE:
      return merge(state, {
        clicks: {
          ...ReduxRestEntity.initialState,
        },
      });
    case TYPES.UPDATE_SPONSORSHIP_REQUEST:
      return merge(state, {
        sponsorshipCart: merge(state.sponsorshipCart, {
          isLoading: true,
          error: null,
        }),
      });
    case TYPES.UPDATE_SPONSORSHIP_SUCCESS:
      return merge(state, {
        sponsorshipCart: merge(state.sponsorshipCart, {
          isLoading: false,
          error: null,
        }),
      });
    case TYPES.UPDATE_SPONSORSHIP_FAILURE:
      return merge(state, {
        sponsorshipCart: merge(state.sponsorshipCart, {
          isLoading: false,
          error: action.payload,
        }),
      });
    case TYPES.GET_SPONSORS_REQUEST:
      return merge(state, {
        jobSponsors: merge(state.jobSponsors, {
          isLoading: true,
          error: null,
        }),
      });
    case TYPES.GET_SPONSORS_SUCCESS:
      return merge(state, {
        jobSponsors: merge(state.jobSponsors, {
          isLoading: false,
          error: null,
          data: action.payload,
        }),
      });
    case TYPES.GET_SPONSORS_FAILURE:
      return merge(state, {
        jobSponsors: merge(state.jobSponsors, {
          isLoading: false,
          error: action.payload,
        }),
      });
    case TYPES.CREATE_SPONSORSHIP_REQUEST:
      return merge(state, {
        jobSponsors: merge(state.jobSponsors, {
          isLoading: true,
          error: null,
        }),
      });
    case TYPES.CREATE_SPONSORSHIP_SUCCESS:
      return merge(state, {
        jobSponsors: merge(state.jobSponsors, {
          isLoading: false,
          error: false,
        }),
      });
    case TYPES.CREATE_SPONSORSHIP_FAILURE:
      return merge(state, {
        jobSponsors: merge(state.jobSponsors, {
          isLoading: false,
          error: action.payload,
        }),
      });
    case TYPES.EXPIRED_SPONSORSHIPS_REQUEST:
      return merge(state, {
        expiredJobSponsorships: merge(state.expiredJobSponsorships, {
          isLoading: true,
          error: null,
        }),
      });
    case TYPES.EXPIRED_SPONSORSHIPS_SUCCESS:
      return merge(state, {
        expiredJobSponsorships: merge(state.expiredJobSponsorships, {
          data: action.payload,
          error: false,
          isLoading: false,
        }),
      });
    case TYPES.EXPIRED_SPONSORSHIPS_FAILURE:
      return merge(state, {
        expiredJobSponsorships: merge(state.expiredJobSponsorships, {
          isLoading: false,
          error: action.payload,
        }),
      });
    case TYPES.CLEAR_STATE:
      return INITIAL_STATE;
    case TYPES.CLEAR_SPONSORSHIP_CART:
      return merge(state, {
        sponsorshipCart: {
          ...INITIAL_STATE.sponsorshipCart,
        },
      });
    case TYPES.GET_OVERVIEW_REPORT_REQUEST:
      return merge(state, {
        overviewReport: merge(state.overviewReport, {
          error: null,
          isLoading: true,
        }),
      });
    case TYPES.GET_OVERVIEW_REPORT_SUCCESS:
      return merge(state, {
        overviewReport: merge(state.overviewReport, {
          data: action.payload,
          error: false,
          isLoading: false,
        }),
      });
    case TYPES.GET_OVERVIEW_REPORT_FAILURE:
      return merge(state, {
        overviewReport: merge(state.overviewReport, {
          error: action.payload,
          isLoading: false,
        }),
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
